import React from 'react';
import Dropdown from '@pushpay/dropdown';
import { ChurchManagementSoftwareIcon, CustomerAdminPortalIcon, ExternalLinkIcon, InsightsIcon, MobileAppStudioIcon } from '@pushpay/iconography';
import { Menu } from '@pushpay/menu';
import { clsx } from '@pushpay/styles';
import { memo } from '@pushpay/types';
import { deepEqual } from '@pushpay/utils';
import { useLink } from '../link-provider';
import { ProductSwitcherItem } from './product-switcher-item';
import { useStyles } from './styles';

const ProductSwitcherComponent = ({
  currentProductDisplayStyle = 'label',
  isMobile = false,
  buttonLabel,
  title,
  noOrgAcessTitle,
  pushpayMarketing,
  givingProps,
  appStudioProps,
  chmsProps,
  insightsProps,
  tooltips,
  classes: classesProp,
  className: classNameProp,
  'data-pp-at-target': targetId,
  alignment,
  ...rest
}) => {
  const classes = useStyles(classesProp, {
    isMobile,
    currentProductDisplayStyle
  });
  const className = clsx(classNameProp, classes.root);
  const {
    Link
  } = useLink();
  const allProducts = [{
    name: 'giving',
    props: givingProps,
    icon: CustomerAdminPortalIcon
  }, {
    name: 'appStudio',
    props: appStudioProps,
    icon: MobileAppStudioIcon
  }, {
    name: 'chms',
    props: chmsProps,
    icon: ChurchManagementSoftwareIcon
  }, insightsProps ? {
    name: 'insights',
    props: insightsProps,
    icon: InsightsIcon
  } : undefined].filter(Boolean);

  const overlay = () => {
    var _allProducts$find$pro, _allProducts$find;

    const {
      productsOrgHas,
      productsOrgDoesNotHave
    } = allProducts.reduce((acc, product) => {
      const productElement = /*#__PURE__*/React.createElement(ProductSwitcherItem, {
        key: product.name,
        classes: classesProp,
        productProps: product.props,
        tooltips: tooltips,
        icon: product.icon,
        "data-pp-at-target": `${targetId}-${product.name}`
      });

      if (product.props.access === 'organizationNoProduct') {
        acc.productsOrgDoesNotHave.push(productElement);
      } else {
        acc.productsOrgHas.push(productElement);
      }

      return acc;
    }, {
      productsOrgHas: [],
      productsOrgDoesNotHave: []
    });
    const selectedItem = (_allProducts$find$pro = (_allProducts$find = allProducts.find(product => product.props.access === 'current')) === null || _allProducts$find === void 0 ? void 0 : _allProducts$find.props.label) !== null && _allProducts$find$pro !== void 0 ? _allProducts$find$pro : null;
    return /*#__PURE__*/React.createElement(Menu, {
      onItemSelected: () => {},
      selectedItem: selectedItem,
      focusBehavior: "arrowKeys",
      displayStyle: "neutral"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.panel
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.header
    }, /*#__PURE__*/React.createElement("strong", {
      className: classes.title
    }, title), /*#__PURE__*/React.createElement(Link, {
      className: classes.marketingLink,
      displayStyle: "unstyled",
      href: pushpayMarketing.url,
      title: pushpayMarketing.title,
      target: "_blank",
      "data-pp-at-target": `${targetId}-pushpay-website-link`
    }, pushpayMarketing.label, /*#__PURE__*/React.createElement(ExternalLinkIcon, {
      position: "right",
      "data-pp-at-target": `${targetId}-pushpay-website-icon`
    }))), productsOrgHas, productsOrgDoesNotHave.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.noAccessDividerContainer
    }, /*#__PURE__*/React.createElement("hr", {
      className: classes.noAccessDivider
    })), /*#__PURE__*/React.createElement("strong", {
      className: classes.noOrgAccessTitle
    }, noOrgAcessTitle), productsOrgDoesNotHave)));
  };

  const currentProduct = allProducts.find(product => product.props.access === 'current');

  if (!currentProduct) {
    throw new Error('No current product found');
  }

  const CurrentProductIcon = currentProduct.icon;
  return /*#__PURE__*/React.createElement(Dropdown, Object.assign({
    className: className,
    classes: {
      summary: classes.button,
      overlay: clsx({
        [classes.productSwitcherMobileOverlay]: isMobile
      })
    },
    overlay: overlay,
    "data-pp-at-target": targetId,
    alignment: alignment,
    mobileBreakpoint: "NEVER",
    "aria-label": buttonLabel
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: classes.currentProduct
  }, /*#__PURE__*/React.createElement(CurrentProductIcon, {
    className: classes.currentProductItemIcon,
    "data-pp-at-target": `${targetId}-${currentProduct.name}-icon`
  }), !isMobile && currentProductDisplayStyle === 'label' && /*#__PURE__*/React.createElement("p", {
    className: classes.currentProductLabel
  }, currentProduct.props.label)));
};

export const ProductSwitcher = memo(ProductSwitcherComponent, deepEqual);